import { useContext } from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../elements/button';
import { Image } from '../elements/image';
import { Text } from '../elements/text';
import { AppContext } from '../context/app-context';
import { getEntryPointRoute } from '../utils/get-entry-point-route';

export const NoActiveOrders = () => {
  const navigate = useNavigate();
  const { venueType, store: storeInContext } = useContext(AppContext);
  const { t } = useTranslation(['patron_portal', 'common']);

  return (
    <Grid container display={'flex'} justifyContent={'center'} mt={12}>
      <Grid item>
        <Box textAlign={'center'}>
          <Box maxWidth={150} maxHeight={200} m="auto">
            <Image src={require('../assets/images/empty-cart.png')} />
          </Box>

          <Box mt={2}>
            <Text
              fontSize={24}
              fontWeight={600}
              text={t('patron_portal.order.msgNoActiveOrders', {
                ns: 'patron_portal',
              })}
            />
          </Box>

          {/* <Box mt={1}>
            <Text
              fontSize={18}
              text={t('patron_portal.order.msgCreateOrder', {
                ns: 'patron_portal',
              })}
            />
          </Box> */}
        </Box>
        <Box mt={3} mb={1}>
          <CustomButton
            onClick={() =>
              navigate(
                getEntryPointRoute(
                  venueType?.value || '',
                  storeInContext?.value,
                ),
              )
            }
            title={t('patron_portal.cart.btnLabelFillCart', {
              ns: 'patron_portal',
            })}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
